import React, { Component } from 'react';
import * as helpers from '../helpers/helpers';
import './SidebarItemList.css';
class SidebarItemList extends Component {
  constructor(props) {
    super(props);

    // BIND THIS TO THE CLICK FUNCTION
    this.buttonClick = this.buttonClick.bind(this);

    this.state = {
      components: [],
    };
  }

  buttonClick(name) {
    //PARENT HANDLES THE REST
    this.props.onTabClick(name);
  }
  componentDidMount() {
    helpers.waitForLoad(['settings', 'sidebar'], Date.now(), 30, () => {
      let listItems = null;
      if (this.props.listtype === 'tools') {
        let tools = window.config.sidebarToolComponents;
        listItems = tools.filter(
          (item) => item.enabled === undefined || item.enabled
        );
      } else {
        // IMPORT THEMES FROM CONFIG
        let themes = window.config.sidebarThemeComponents;
        listItems = themes.filter(
          (item) => item.enabled === undefined || item.enabled
        );
      }
      this.setState({ components: listItems }, () => {
        helpers.addIsLoaded('toolsAndThemes');
      });
    });
  }

  render() {
    // GET LIST OF COMPONENTS FROM CONFIG
    return (
      <div className="region-sidebarlist-container">
        {
          // CREATE ITEMS FROM CONFIG
          this.state.components.map((listItem) => {
            // SKIP IF ITS DISABLED
            if (listItem.disable !== undefined && listItem.disable) return null;
            return (
              <ToolItem
                componentname={listItem.componentName}
                onClick={() =>
                  this.props.onClick(listItem.name, this.props.listtype)
                }
                key={helpers.getUID()}
                id={listItem.id}
                name={listItem.name}
                imageName={listItem.imageName}
                description={listItem.description}
              />
            );
          })
        }
      </div>
    );
  }
}

export default SidebarItemList;

// ITEM
class ToolItem extends Component {
  state = {};

  render() {
    return (
      // <div className="region-sidebarlist-item" >
      <div
        className="region-sidebarlist-item"
        onClick={
          this.props.componentname !== 'disabledTheme'
            ? this.props.onClick
            : () => {}
        }
        style={{
          opacity: this.props.componentname === 'disabledTheme' ? '60%' : '',
          cursor:
            this.props.componentname === 'disabledTheme'
              ? 'default'
              : 'pointer',
        }}
      >
        <div className="region-sidebarlist-item-iconbackground">
          <div className="region-sidebarlist-item-icon" />
          <img
            className="app-icon"
            src={images[this.props.imageName]}
            alt="Tool Item"
          />
        </div>
        <div className="region-sidebarlist-item-text-container">
          <div className="region-sidebarlist-item-text-title">
            {this.props.name}
          </div>
          <div className="region-sidebarlist-item-text-description">
            {this.props.description}
          </div>
        </div>
      </div>
    );
  }
}

//IMPORT ALL IMAGES
const images = importAllImages(
  require.context('./images', false, /\.(png|jpe?g|svg)$/)
);
function importAllImages(r) {
  let images = {};
  r.keys().map((item, index) => (images[item.replace('./', '')] = r(item)));
  return images;
}
